import { Navigate, useLocation } from 'react-router-dom';
import { ChannelModuleLayout } from '@/features/marketing-shared/ui/channel-module-layout';
import { EmailMarketingProvider, useEmailMarketing } from '../model/context';
import { useEmailMarketingPaths } from '../model/paths';

function isTemplateWorkspace(pathname: string) {
  return /\/email-marketing\/templates\/(novo|[^/]+\/editar)$/.test(pathname);
}

function ModuleFrame() {
  const { gate, campaignsState } = useEmailMarketing();
  const { pathname } = useLocation();
  return (
    <ChannelModuleLayout
      title="E-mail marketing"
      description="Módulo separado das campanhas atuais e do SMS."
      gate={gate}
      onRetry={campaignsState.refetch}
      deniedTitle="Sem permissão para e-mail marketing"
      deniedDescription="O acesso deste módulo é separado das campanhas atuais e do SMS. Só Admin, Client ou Owner da loja entram aqui."
      uncontractedTitle="E-mail marketing não contratado"
      uncontractedDescription="Este módulo tem contratação própria e não inclui SMS. As campanhas que você já usa continuam no menu Campanhas. Para contratar, fale com o time da Fixe."
      workspace={isTemplateWorkspace(pathname)}
    />
  );
}

export function EmailMarketingLayout() {
  return (
    <EmailMarketingProvider>
      <ModuleFrame />
    </EmailMarketingProvider>
  );
}

export function EmailMarketingIndexRedirect() {
  const paths = useEmailMarketingPaths();
  return <Navigate to={paths.list} replace />;
}
